import React from 'react';
import { Link } from "react-router-dom";


function MyBlogs(props) {

  return (
    <>
    <div className="card d-flex" style={{width:"100%", maxWidth: "30rem", height:"auto", alignItems:"center", justifySelf:"center", paddingTop:"1.7rem",paddingBottom: "1.7rem", boxShadow:"1rem 1rem 2.5rem #E7E9EB", border:"none"}}>
      <div className="card-body text-start">
        <h3 className="card-title" style={{border:"none", backgroundColor:"#ffffff", fontSize:"1.25rem", color:"#000000"}}><strong>{props.title}</strong></h3>
        <p className="card-title" style={{border:"none", backgroundColor:"#ffffff", fontSize:"1rem", color:"#000000", margin:"1rem 0"}}>{props.text}</p>
        <button className="btn" type="button" style={{backgroundColor:"#0292FD", color:"#ffffff"}}><Link to={props.to} style={{textDecoration:"none", color:"#ffffff"}}>Read More</Link></button>

        {/*<div>
          {
            !hidden?<button className="btn" type="button" style={{backgroundColor:"#0292FD", color:"#ffffff"}}><Link to={props.to} style={{textDecoration:"none", color:"#ffffff"}}>Read More</Link></button>:null
          }
        </div>*/}
      
      </div>
    </div>
    </>
  )
}

export default MyBlogs;




















